import { Button, Image, Text } from "@primitives";
import React from "react";

const page = () => {
  return (
    <div className="grid columns-1 justify-start gap-3 border-2 border-primaryOne p-3 main-column">
      <Button className="mb-4">Primary Button</Button>
      <Button variant="secondary">Secondary Button</Button>
      <Text as="h1" className="text-utilitarianFive">
        Heading 1
      </Text>
      <Text as="h2" className="text-secondaryThree">
        Heading 2
      </Text>
      <Text as="h3" className="text-secondaryTwo">
        Heading 3
      </Text>
      <Text as="h4">Heading 4</Text>
      <Text as="h5">Heading 5</Text>
      <Text as="h6">Heading 6</Text>
      <Image
        src="/images/client-placeholder.jpg"
        className="h-[200px] w-[400px]"
      />
      <Image
        src="/images/client-placeholder.jpg"
        className="aspect-ratio-[1.66]"
      />
      <h2 className="typography-h2">yooo</h2>

      <div className="text-gray-700 shadow-md h-24  flex border-2 p-3">
        yoooo
      </div>
      <h1 className="typography-h3 border-2 lg:typography-h1">yooo</h1>
      <div className="size-[200px] border-2 border-secondaryTwo" />
    </div>
  );
};

export default page;
